module.exports = __webpack_public_path__ + "files/import-non-menu-more-template.xlsx";